import { preprocessAudit } from "../../containers/AppPage/Reports/AuditTrails/View/helper";
import { setErrorReducer, setRequestReducer, setSuccessReducer } from "../helper";
import actions from "./actions";
import { AuditName } from "./enums";

const initAuditByNameState = {
    // audit logs
    auditId: null,

    auditReadAllState: false,
    audits: [],
    auditsPagination: {},

    auditReadState: false,
    audit: {},
    processedAudit: {}, // with before and after
};

function initState() {
    const initState = {
        auditsDrawerOpen: false, // is the audits drawer open
        currentAuditName: false, // the current audit name (based on drawer opened) - AuditName.ACCOUNT, AuditName.CONTACT, AuditName.PRODUCT
    };

    // Each AuditName has its own state
    Object.keys(AuditName).forEach(key => {
        initState[key] = initAuditByNameState;
    });
    return initState;
}

// reducer for each audit module
function auditReducer(auditName, state, action) {
    switch (action.type) {
        // case actions.AUDIT_MODULE_TOGGLE_AUDITS_DRAWER:
        //     return {
        //         ...state,
        //         auditsDrawerOpen: action.auditsDrawerOpen,
        //     };
        case actions.AUDIT_MODULE_SET_ID:
            return {
                ...state,
                auditId: action.id,
            };
        case actions.AUDIT_MODULE_READ_ALL_REQUEST:
            return setRequestReducer(state, 'auditReadAllState');
        case actions.AUDIT_MODULE_READ_ALL_SUCCESS:
            console.log('aaa setSuccessReducer 3', setSuccessReducer(state, 'auditReadAllState', {
                audits: action.audits,
                auditsPagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
            }));

            return setSuccessReducer(state, 'auditReadAllState', {
                audits: action.audits,
                auditsPagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
            });
        case actions.AUDIT_MODULE_READ_ALL_ERROR:
            return setErrorReducer(state, 'auditReadAllState');
        case actions.AUDIT_MODULE_READ_REQUEST:
            return setRequestReducer(state, 'auditReadState');
        case actions.AUDIT_MODULE_READ_SUCCESS:
            return setSuccessReducer(state, 'auditReadState', {
                audit: action.audit,
                processedAudit: preprocessAudit(action.audit),
            });
        case actions.AUDIT_MODULE_READ_ERROR:
            return setErrorReducer(state, 'auditReadState');

        case actions.AUDIT_MODULE_RESET_STATE:
            return {
                ...initState,
            };
        case actions.AUDIT_MODULE_RESET_AUDIT:
            return {
                ...state,
                audit: {},
                processedContactAudit: {},
            };
        case actions.AUDIT_MODULE_RESET_ID:
            return {
                ...state,
                auditId: null,
            };
        default:
            return state;
    }
}

export default function appReducer(state = initState(), action = {}) {
    const { auditName } = action;

    const auditReducerByType = state[auditName] || initAuditByNameState;

    // console.log('aaa initReducer', {
    //     type,
    //     // auditName,
    //     // initTable,
    //     state,
    //     action,
    //     newState: {
    //         ...state,
    //         [auditName]: auditReducer(auditName, auditReducerByType, action),
    //     },
    // });

    switch (action.type) {
        // apply to all audit modules
        case actions.AUDIT_MODULE_TOGGLE_AUDITS_DRAWER:
            return {
                ...state,
                auditsDrawerOpen: action.auditsDrawerOpen,
                currentAuditName: action.auditName,
            };
        case actions.AUDIT_MODULE_SET_NAME:
            return {
                ...state,
                currentAuditName: action.auditName,
            };

        // specific audit module
        default:
            return {
                ...state,
                [auditName]: auditReducer(auditName, auditReducerByType, action),
            };
    }
}
